import React from 'react';
import { useFormContext } from 'react-hook-form';
import RecipientItemActions from '#component/shipment/form/notification/recipient-item-actions';
import AutocompleteServiceField from '#component/general/autocomplete-service-field';
import { useOptionsService } from '#service/autocomplete-service/hooks';
import { RecipientShipmentOptionService } from '#service/autocomplete-service/service';
import RecipientFieldItem from '#component/shipment/form/notification/form/recipient-field-item';
import {
  ItemContainer,
  StyledIconButton
} from './style';

const filterOptions = (options, selectedOptions) =>
  options.filter(o => {
    const v = `${o.data.firstName} ${o.data.lastName}`;
    return !selectedOptions.some(s =>
      s.value === v && s.id === o.data.id && s.type === o.data.type);
  }).slice(0, 5);

const searchFields = ['fullName', 'email', 'company'];

const RecipientItem = props => {
  const {
    index,
    selectedRecipients,
    member,
    change: changeProp,
    remove,
    disabled
  } = props;

  const { setValue } = useFormContext();
  const change = changeProp || ((name, value) =>
    setValue(name, value, { shouldDirty: true, shouldValidate: true }));

  const deleteRecipientItem = event => {
    event.stopPropagation();
    remove(index);
  };

  const updateFormFields = option => {
    change(`${member}.id`, option.id);
    change(`${member}.type`, option.type);
    change(`${member}.email`, option.email ?? null);
    // fetched (selected) data doesn't have `value`
    if (!option.value) {
      change(`${member}.value`, `${option.firstName} ${option.lastName}`);
    }
  };

  const fieldDescription = selectedRecipients[index]?.value?.data?.email ||
    (selectedRecipients[index]?.value && selectedRecipients[index].email);

  return (
    <ItemContainer>
      <AutocompleteServiceField
        name={`${member}.value`}
        className="textField"
        disabled={disabled}
        inputProps={{ variant: 'outlined' }}
        filterOptions={options => filterOptions(options, selectedRecipients)}
        renderOption={(optionProps, option) => <RecipientFieldItem optionProps={optionProps} change={change} name={`${member}.value`} {...option} />}
        onOptionChange={updateFormFields}
        useOptionsService={useOptionsService}
        useOptionsServiceArgs={[searchFields]}
        useOptionServiceProvider={RecipientShipmentOptionService}
        getOptionDisabled={option => !option.data.email}
        disabledItemsFocusable={true}
        description={fieldDescription || true}
        change={(name, value) => {
          change(name, value);
          // reset fields attributes to default (email)
          updateFormFields({ id: null, type: 'email', value });
        }}
      />
      <RecipientItemActions
        deleteRecipientItem={deleteRecipientItem}
        StyledIconButton={StyledIconButton}
        disabled={disabled}
      />
    </ItemContainer>);
};

export default RecipientItem;
